var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextTtOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 6.8L8.89998 6.8V18.1C8.89998 18.5971 8.49703 19 7.99998 19C7.50292 19 7.09998 18.5971 7.09998 18.1V6.8Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.9C2 5.40294 2.40294 5 2.9 5H13.1C13.5971 5 14 5.40294 14 5.9C14 6.39706 13.5971 6.8 13.1 6.8H2.9C2.40294 6.8 2 6.39706 2 5.9Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.9C12 9.40294 12.4029 9 12.9 9H21.1C21.5971 9 22 9.40294 22 9.9C22 10.3971 21.5971 10.8 21.1 10.8H12.9C12.4029 10.8 12 10.3971 12 9.9Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 10.7958H17.9V18.1C17.9 18.5971 17.4971 19 17 19C16.5029 19 16.1 18.5971 16.1 18.1V10.7958Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTtOutline);
export default __webpack_public_path__ + "static/media/text_tt_outline.0822c680b7321768386637fd873c4ab8.svg";
export { ForwardRef as ReactComponent };